<template>
  <GwMenu
    class="h-100 d-flex"
    trigger="hover"
    placement="bottom"
    :flOptions="{ offset: 0, padding: 0 }"
  >
    <template #opener>
      <router-link
        class="h-100"
        :to="{ name: links_practice_all[0].pathName }"
        data-tst="practice_menu_link_main"
      >
        <NavCard
          :item="links_practice_all[0]"
          class="navcard_menu navcard_menu-trigger navcard_router-link"
          :style="'--clr-text:var(--clr-grey-2); --padding: 0 1rem;'"
          :hasSub="false"
        >
        </NavCard>
      </router-link>
    </template>
    <template #default="{ methods }">
      <div
        class="gw_menu"
        style="padding: 0"
        @click="methods.toggleOpen(false)"
      >
        <div class="app-group-menu">
          <router-link
            v-for="item in links_practice.filter(
              item => !item.disabled && item.id !== 'Practice' && item.pathName !== 'PracticePlay',
            )"
            :key="item.pathName"
            :to="{ name: item.pathName, query: item.query || {} }"
            :class="{ 'no-events opacity_7s': item.disabled }"
            :data-tst="`practice_menu_link_${item.pathName}`"
          >
            <NavCard
              :item="item"
              :hasIcon="false"
              :hasTitleIcon="true"
              class="navcard_menu navcard_reversed_l text-nowrap navcard_router-link"
              :style="`
          ${item.tag_live ? tagLiveStyle : ''};
          ${item.style}
           `"
              :hasTag="!!item.tag_live"
              @click="
                e => {
                  if (item.pathName === $route.name) {
                    links_clickPreventLocalNav(e)
                  }
                }
              "
            />
          </router-link>
        </div>
      </div>
    </template>
  </GwMenu>
</template>

<script>
import GwMenu from '@/components/lib/GwMenu'
import links_mix from '@/mixins/links_mix'

export default {
  name: 'PracticeMenu',
  components: {
    GwMenu,
  },
  mixins: [links_mix],
  data() {
    return {
      tagLiveStyle: `
          --tag-height:1rem;--tag-size:0.8rem;
          --tag-padding:0 0.25rem;--clr-tag:var(--clr-white-0); --clr-tag-back: var(--clr-error);
          `,
    }
  },
}
</script>
